import React, { useEffect, useState, useContext } from 'react'; 
import Card from './card.component';
import {
  Col,
  Row,
  Button,
} from 'react-bootstrap';
import empresaFunction from '../views/configuracion/configuracion.function';
import notification from './notification.component';
import DataTable from 'react-data-table-component';
import {
    faCheckSquare,
    faMinusSquare,
  } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConfirmAlertV2 from './confirmv2.component';
import { ConfigContext } from '../context/config.context';



const ConfiguracionExtra = ({ data }) => {

  const { updateConfigExtra } = useContext(ConfigContext);
  const [extras, setExtras] = useState(data.operaciones);
  const [accion, setAccion] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (accion) {
        setShow(true);
    }
  },[accion]);

  useEffect(() => {
    setExtras(data.operaciones);
  },[data])

  const accionSeleccionada = (opcion) => {
    setAccion(opcion);
  }

  const toggle = () => {
    setShow(!show);  
  }

  const confirmaraccion = () => {
     const playload = {
         id: accion.operacion_id,
         valor: !accion.valor_permiso,
     }
     empresaFunction.extrasUpdate(playload).then((response) => {
        if (response.error) {
            notification.warning();
        } else {
            notification.success('Se aplico el cambio con éxito');
            updateConfigExtra(response.configExtra);
            setAccion(null);
        }
     });
  }

  const columns = [
    {
      name: 'Atributo',
      selector: row => row.config_extra.nombre_atributo,
      sortable: true,
    },
    {
      name: 'Estado',
      selector: 'valor_permiso',
      sortable: true,
      right: true,
      cell: row => (
        <Button onClick={() => accionSeleccionada(row)}
            variant={row.valor_permiso ? "success" : "danger"} 
            size="sm"
            className="m-1"
        >
          <FontAwesomeIcon icon={row.valor_permiso ? faCheckSquare : faMinusSquare} />
        </Button>
      )
    },
  ];
  
  const customStyles = {
    rows: {
        style: {
        minHeight: '72px', // override the row height
        }
    },
    headCells: {
        style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        },
    },
    cells: {
        style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
        },
    },
  };

  


  return (
    <>
    <Row className="mt-3">
      <Col>
        <Card>
          <Row>
              <Col>
                <DataTable
                    title="Configuración extra"
                    data={extras}
                    noHeader={false}
                    columns={columns}
                    customStyles={customStyles}
                    dense={true}
                    pagination={true}
                    paginationPerPage={15}
                    paginationRowsPerPageOptions={[5]}
                    noDataComponent={"No existen datos asociados a la busqueda."}
                />
            </Col>
          </Row>
        </Card>
      </Col>
   </Row>
   <ConfirmAlertV2
      show={show}
      onCancel={toggle}
      onConfirm={confirmaraccion}
      typeBtn="hidden"
   />
   </>
  )
}

export default ConfiguracionExtra;